import api from "../../Utils/interceptors";

export const getTaxConfigs = () => async (dispatch) => {
  try {
    dispatch({ type: "GET_TAX_CONFIGS_REQUEST" });
    const { data } = await api.get("taxes");
    dispatch({ type: "GET_TAX_CONFIGS_SUCCESS", payload: data });
  } catch (e) {
    dispatch({
      type: "GET_TAX_CONFIGS_FAILED",
      payload: e.response?.data?.message,
    });
  }
};

export const createTaxConfig = (payload) => async (dispatch) => {
  try {
    dispatch({ type: "CREATE_TAX_CONFIG_REQUEST" });
    const { data } = await api.post("taxes", payload);
    dispatch({ type: "CREATE_TAX_CONFIG_SUCCESS", payload: data });
  } catch (e) {
    dispatch({
      type: "CREATE_TAX_CONFIG_FAILED",
      payload: e.response?.data?.message,
    });
  }
};

export const updateTaxConfig = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: "UPDATE_TAX_CONFIG_REQUEST" });
    const { data } = await api.put(`taxes/${id}`, payload);
    dispatch({ type: "UPDATE_TAX_CONFIG_SUCCESS", payload: data });
  } catch (e) {
    dispatch({
      type: "UPDATE_TAX_CONFIG_FAILED",
      payload: e.response?.data?.message,
    });
  }
};

export const clearErrors = () => async (dispatch) => {
  dispatch({ type: "CLEAR_ERRORS" });
};

